import { Col, Layout } from "antd";
import React, { useState, useContext, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MenuFoldOutlined, PushpinOutlined } from "@ant-design/icons";
import "../../assets/css/omessage.css";
import { HOMEPAGE_URL, navigateToPathWithCurrentParams, OTP_MODAL_EXCLUDE_PATHS } from "../../pages/utils/commonUtils";
import SideBarMenuItem from "./SideBarItemComponents/SideBarMenuItem";
import "../../assets/css/services/sidebar.css";
import { AppContext } from "../../context/AppContext";
import useRecordService from "../../pages/recordManagement/useRecordService";

const { Sider } = Layout;

function Sidebar(props) {
  const { toggleSidebar, isPinned, togglePin, handleNavigation, isFloating, setAccessDenied } = props;
  const [appProperties, setAppProperties] = useContext(AppContext);
  const recordService = useRecordService();
  const [searchParams] = useSearchParams();
  let sideBarNeeded = searchParams?.get("sideBar");
  const navigate = useNavigate();
  let path = window.location.pathname;
  if (
    path === "/zoho-crm/webhook" ||
    path.includes("/login") ||
    path.includes("/signin") ||
    path.includes("/signup") ||
    path.includes("/web/apps")
  ) {
    sideBarNeeded = "false";
  }
  var sideBarFalse = "block";
  if (OTP_MODAL_EXCLUDE_PATHS.includes(path)) {
    sideBarFalse = "d-none";
  }
  const isSideBarNeeded = useMemo(() => !sideBarNeeded || sideBarNeeded !== "false", [sideBarNeeded]);

  const checkContactsStatus = useCallback(async () => {
    try {
      const hasAnyRecords = await recordService.hasAnyRecords();
      setAppProperties((prev) => ({
        ...prev,
        hasContacts: hasAnyRecords,
      }));
    } catch (error) {
      console.error("Error checking contact records:", error);
      setAppProperties((prev) => ({
        ...prev,
        hasContacts: false,
      }));
    }
  }, [recordService, setAppProperties]);

  useEffect(() => {
    if (appProperties?.controller?.contactsEnabled && appProperties?.osyncId && appProperties?.hasContacts === undefined) {
      checkContactsStatus();
    }
  }, [checkContactsStatus, appProperties?.osyncId, appProperties?.hasContacts, appProperties?.controller?.contactsEnabled]);

  return (
    <>
      {isSideBarNeeded && (
        <Sider
          theme="light"
          className={`hs-min-w-210-px overflow-y-auto ${sideBarFalse}`}
          style={{
            height: "100dvh",
            top: 0,
            bottom: 0,
            zIndex: 1,
            background: "white",
            borderInlineEnd: "1px solid #E5E7EB",
          }}
        >
          <div className="demo-logo-vertical" />
          <div className="d-flex justify-content-between align-items-center">
            <div
              key="logo"
              style={{ height: "100px" }}
              title=""
              className="hellosendHover"
              onClick={() => {
                navigateToPathWithCurrentParams(HOMEPAGE_URL, navigate);
                handleNavigation(); // Close sidebar if in floating mode
              }}
            >
              <div className="d-flex justify-content-left ps-4">
                <Col className="mt-3">
                  <div className="static-icon-for-logo sideBar-hellosend-logo" title=""></div>
                </Col>
                <Col className="mt-3 pt ms-1">
                  <div
                    style={{
                      textTransform: "capitalize",
                      color: "#111827",
                      fontWeight: 700,
                      fontSize: 18,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      marginTop: "10px",
                    }}
                  >
                    HelloSend
                  </div>
                </Col>
              </div>
            </div>
            <div className="d-flex">
              {/* Pin/Unpin button */}
              <div
                className={`sidebar-pin-btn ${isPinned ? "pinned" : ""}`}
                onClick={togglePin}
                style={{
                  padding: "8px",
                  marginRight: "2px",
                  cursor: "pointer",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "while",
                  boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",

                  marginTop: "20px",
                }}
                title={isPinned ? "Unpin sidebar" : "Pin sidebar"}
                data-cy="pin-sidebar"
              >
                <PushpinOutlined
                  style={{
                    fontSize: "16px",
                    transform: isPinned ? "rotate(-45deg)" : "none",
                    color: isPinned ? "#1890ff" : "inherit",
                  }}
                />
              </div>

              {/* Collapse button */}
              {!isPinned && !isFloating && (
                <div
                  className="sidebar-collapse-btn"
                  onClick={toggleSidebar}
                  style={{
                    padding: "8px",
                    marginRight: "8px",
                    cursor: "pointer",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MenuFoldOutlined style={{ fontSize: "16px" }} />
                </div>
              )}
            </div>
          </div>
          <SideBarMenuItem
            toggleSidebar={toggleSidebar}
            sideBarCommonHandling={false}
            handleNavigation={handleNavigation}
            setAccessDenied={setAccessDenied}
          />
        </Sider>
      )}
    </>
  );
}

export default Sidebar;
